import React, { useState } from 'react';
import useUser from '@vl-core/hooks/useUser';
import { InfoModal } from 'vl-common/src/components/Modals';
import useArticle from 'vl-common/src/hooks/useArticle';

export const SsoWelcomeModal = () => {
  const user = useUser();

  const [open, setOpen] = useState(false);

  const article = useArticle('self_reg_sso_onboarding_message');

  if (user.ident_prov_code === 'COGNITO' || !article) return null;

  return (
    <InfoModal title={article?.title || ''} open={open} onOk={() => setOpen(false)}>
      <div css={{ marginBottom: 16 }} dangerouslySetInnerHTML={{ __html: article.body }} />
    </InfoModal>
  );
};
